export default __webpack_public_path__ + "static/media/error.dbe17caa.png";